// @ts-nocheck
import { useState, useEffect } from 'react';
import axios from 'axios';

export function useBrowserLocation() {
  const [location, setLocation] = useState(window.location);
  const [address, setAddress] = useState(null);

  useEffect(() => {
    const watchId = navigator.geolocation.watchPosition(
      async (position) => {
        const coords = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        };
        setLocation({
          ...window.location,
          coords,
        });

        // Get the address from OpenStreetMap
        const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${coords?.latitude}&lon=${coords?.longitude}`;
        try {
          const response = await axios.get(url);
          setAddress(response?.data?.display_name); // Set the address
        } catch (error) {
          console.error('Failed to get address from coordinates:', error);
        }
      },
      (error) => {
        setLocation({
          ...window.location,
          coords: {
            latitude: null,
            longitude: null,
          },
        });
        console.error('Failed to get location:', error);
      },
    );

    return () => {
      navigator.geolocation.clearWatch(watchId);
    };
  }, []); // Empty dependency array ensures this effect runs only once

  return { location, address };
}
